import './currencyNameCell.scss';

interface ICurrencyNameCell {
  flag?: string;
  name?: string | null;
}

/** Muestra la bandera de la moneda junto al nombre. */
const CurrencyNameCell = ({ flag, name }: ICurrencyNameCell) => {
  const displayName = name || '—';
  const flagStyle = flag ? { backgroundImage: `url(${flag})` } : undefined;

  return (
    <div className="currencyNameCell">
      <div className="currencyNameCellFlag" style={flagStyle} />
      <span className="currencyNameCellLabel">{displayName}</span>
    </div>
  );
};

export default CurrencyNameCell;
